import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { v1 as uuidV1 } from 'uuid';
import { Checkbox, FormControlLabel, Radio } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import SmartPagination from '../../../../shared/components/SmartPagination';
import { removeHtml } from '../../../../shared/utils/smartutils';
import {
  QUESTION_TRUE,
  QUESTION_TYPE,
  REPORT_TYPES,
} from '../../../../shared/utils/constants';
import MDIconButton from '../../../../shared/components/MDIconButton';

const IndividualAnswer = ({ t, individual, printReport }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const currentPageChange = (page) => {
    setCurrentPage(page);
  };

  const getIndex = () => currentPage - 1;

  const descriptive = (item) => {
    return (
      <>
        {item.answers.map((answer) => (
          <div key={uuidV1()} className="text-disable mb-2">
            {answer.responsibleAnswer}
          </div>
        ))}
      </>
    );
  };

  const option = (item) => {
    return (
      <>
        {item.answers.map((answer) => (
          <div key={uuidV1()} className="mb-2">
            <div className="d-flex ">
              <FormControlLabel
                className="mb-0"
                control={<Checkbox checked={answer.selected} disabled />}
                label={removeHtml(answer.description)}
              />
            </div>
          </div>
        ))}
      </>
    );
  };

  const objective = (item) => {
    return (
      <>
        {item.answers.map((answer) => (
          <div key={uuidV1()} className="mb-2">
            <div className="d-flex mb-1">
              <FormControlLabel
                className="mb-0"
                control={<Radio checked={answer.selected} disabled />}
                label={removeHtml(answer.description)}
              />
            </div>
          </div>
        ))}
      </>
    );
  };

  const trueOrFalse = (item) => {
    const converterToBool = (answered) => answered === QUESTION_TRUE;
    return (
      <>
        {item.answers.map((answer) => (
          <div key={uuidV1()} className="mb-2">
            <div className="d-flex flex-column mb-1">
              {answer.description}
              <FormControlLabel
                className="mb-0"
                control={<Radio checked disabled />}
                label={t(`answers.${converterToBool(answer.trueOrFalse)}`)}
              />
            </div>
          </div>
        ))}
      </>
    );
  };

  const getPreview = (item) => {
    switch (item.type) {
      case QUESTION_TYPE.DESCRIPTIVE:
        return <>{descriptive(item)}</>;
      case QUESTION_TYPE.SELECTION:
        return <>{option(item)}</>;
      case QUESTION_TYPE.OBJECTIVE:
        return <>{objective(item)}</>;
      case QUESTION_TYPE.TRUE_FALSE:
        return <>{trueOrFalse(item)}</>;
      default:
        return <></>;
    }
  };

  const currentData = individual[getIndex()];

  const currentQuestions =
    individual.length && currentData.questions ? currentData.questions : [];

  return (
    <div>
      <div className="d-flex justify-content-between">
        <SmartPagination
          count={individual.length}
          currentPage={currentPageChange}
        />
        <MDIconButton
          onClick={() => printReport(REPORT_TYPES.RELA_SURVEY_DETAIL)}
          iconPath="mdiPrinter"
          size={1.2}
          tooltip={t('tooltips.download-report')}
        />
      </div>
      <div className="mt-3">
        <div className="mb-3">
          {currentData && currentData.responsible.fullName}
        </div>
        {!!currentQuestions.length &&
          currentQuestions.map((data) => {
            return (
              <div key={uuidV1()} className="mb-3 bg-light p-2">
                <div className="mb-2">{removeHtml(data.description)}</div>
                {getPreview(data)}
              </div>
            );
          })}
      </div>
    </div>
  );
};

IndividualAnswer.propTypes = {
  t: PropTypes.func.isRequired,
  printReport: PropTypes.func.isRequired,
  individual: PropTypes.arrayOf(
    PropTypes.shape({
      responsible: PropTypes.shape({
        id: PropTypes.number,
        fullName: PropTypes.string,
      }),
      questions: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          description: PropTypes.string,
          type: PropTypes.string,
          answers: PropTypes.shape({
            description: PropTypes.string,
            id: PropTypes.number,
            correct: PropTypes.bool,
            selected: PropTypes.bool,
            trueOrFalse: PropTypes.string,
            responsibleAnswer: PropTypes.string,
          }),
        })
      ),
    })
  ).isRequired,
};

export default withTranslation('common')(memo(IndividualAnswer));
